export default __webpack_public_path__ + "static/media/vijaywadaTempleTwo.347efed7.png";